export const theme = {
    colors: {
        lightYellow: '#ffffbb',
        yellow: '#FBB13C',
        brown: '#B66D0D',
        green: '#62ff62',
        blue: 'lightblue',
    },
    spacing: {
        large: '40px',
        medium: '20px',
        small: '10px',
    },
    borderRadius: '5px',
    fontSizes: {
        h1: '24px',
        h2: '20px',
        body: '14px',
    },
};

